import { getFilledTableRows } from '@/utils/misc';
import {
  createPossessionPlayerRows,
  createOffensivePlayerRows,
  createDefensivePlayerRows,
} from '@/utils/dataTablesStructures/normalPlayer';
import {
  createPossessionGoalkeeperRows,
  createOffensiveGoalkeeperRows,
  createDefensiveGoalkeeperRows,
} from '@/utils/dataTablesStructures/goalkeeperPlayer';
import getPlayerStatPlayIndexes from '@/data/player/playerStatsPlayIndexes';
import getLeaguePlayIndexes from '@/data/leaguePlayIndexes';

/**
 * @author Alejandro
 * @description Fill all table data
 * @param {number} analysisType - Can be 1 = Possession, 2 = Offensive, 3 = Defensive
 * @param {boolean} isGoalKeeper
 * @param {Array} playList
 * @param {Array} leaguePlays
 * @param {Array<number>} timeSelected
 * @param {number} totalSeasonGamesOrTeams
 * @return {*}
 */
export function getPlayerTableData(
  analysisType,
  isGoalKeeper,
  playList,
  leaguePlays,
  timeSelected,
  totalSeasonGamesOrTeams,
) {
  let playerDataRows = null;
  if (isGoalKeeper) {
    switch (analysisType) {
      case 2:
        playerDataRows = createOffensiveGoalkeeperRows();
        break;
      case 3:
        playerDataRows = createDefensiveGoalkeeperRows();
        break;
      default:
        playerDataRows = createPossessionGoalkeeperRows();
    }
  } else {
    switch (analysisType) {
      case 2:
        playerDataRows = createOffensivePlayerRows();
        break;
      case 3:
        playerDataRows = createDefensivePlayerRows();
        break;
      default:
        playerDataRows = createPossessionPlayerRows();
    }
  }
  return getFilledTableRows(
    playerDataRows,
    playList,
    leaguePlays,
    timeSelected,
    totalSeasonGamesOrTeams,
    getPlayerStatPlayIndexes(),
    getLeaguePlayIndexes(),
  );
}
